module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "Melinda Ashley Meyer.fb5d296f.jpg" + "?" + Date.now();